module.exports = __webpack_public_path__ + "img/APSicon6.fc5da99a.png";